var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5C0 0.6875 0.65625 0 1.5 0H4.5C5.3125 0 6 0.6875 6 1.5V4.5C6 5.34375 5.3125 6 4.5 6H1.5C0.65625 6 0 5.34375 0 4.5V1.5ZM1.5 4.5H4.5V1.5H1.5V4.5ZM0 9.5C0 8.6875 0.65625 8 1.5 8H4.5C5.3125 8 6 8.6875 6 9.5V12.5C6 13.3438 5.3125 14 4.5 14H1.5C0.65625 14 0 13.3438 0 12.5V9.5ZM1.5 12.5H4.5V9.5H1.5V12.5ZM12.5 0C13.3125 0 14 0.6875 14 1.5V4.5C14 5.34375 13.3125 6 12.5 6H9.5C8.65625 6 8 5.34375 8 4.5V1.5C8 0.6875 8.65625 0 9.5 0H12.5ZM12.5 1.5H9.5V4.5H12.5V1.5ZM8 9.5C8 8.6875 8.65625 8 9.5 8H12.5C13.3125 8 14 8.6875 14 9.5V12.5C14 13.3438 13.3125 14 12.5 14H9.5C8.65625 14 8 13.3438 8 12.5V9.5ZM9.5 12.5H12.5V9.5H9.5V12.5Z",
    fill: "#989CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.96839c6b8054ed234a3ddcfdb6372728.svg";
export { ForwardRef as ReactComponent };